import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FieldGroup } from '../FieldGroup.js';

var RegistrationFieldGroup = /*#__PURE__*/function (_React$Component) {
  function RegistrationFieldGroup(props) {
    var _this;

    _classCallCheck(this, RegistrationFieldGroup);

    _this = _callSuper(this, RegistrationFieldGroup, [props]);
    _this.renderChildren = _this.renderChildren.bind(_this);
    _this.cloneChild = _this.cloneChild.bind(_this);
    return _this;
  }

  _inherits(RegistrationFieldGroup, _React$Component);

  return _createClass(RegistrationFieldGroup, [{
    key: "cloneChild",
    value: function cloneChild(child) {
      if (child && child.key) {
        var field = this.props.metadata[child.key];
        var errorMessage = this.props.errorMessages ? this.props.errorMessages.find(function (error) {
          return error.field_name === child.key;
        }) : null;
        return /*#__PURE__*/React.cloneElement(child, {
          available: field ? field.available : true,
          editable: field ? field.editable : true,
          name: "[".concat(this.props.index, "][").concat(child.key, "]"),
          id: "[".concat(this.props.index, "][").concat(child.key, "]"),
          fieldName: child.key,
          errorMessage: errorMessage
        });
      } else {
        if (child) {
          return this.renderChildren(child);
        }
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(element) {
      var _this2 = this;

      var children = element ? element.props.children : this.props.children;

      if (children) {
        if (Array.isArray(children)) {
          return children.map(function (child) {
            return _this2.cloneChild(child);
          });
        } else {
          var child = React.Children.only(children);
          return this.cloneChild(child);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.metadata) {
        return /*#__PURE__*/React.createElement(FieldGroup, this.props, this.renderChildren());
      } else {
        return null;
      }
    }
  }]);
}(React.Component);

_defineProperty(RegistrationFieldGroup, "propTypes", {
  children: PropTypes.any,
  index: PropTypes.number.isRequired,
  metadata: PropTypes.object.isRequired,
  errorMessages: PropTypes.array
});

RegistrationFieldGroup.displayName = "RegistrationFieldGroup";
export { RegistrationFieldGroup };